module.exports = __webpack_public_path__ + "img/20210903_094850.3869497b.png";